import * as React from 'react'

import { IItemCard } from '../interface'
import AudioPlayer from './audioPlayer'

const LockupAudioPreview = (props: IItemCard) => (
  <AudioPlayer item={props.item} viewType={props.viewType} />
)

export default LockupAudioPreview
